import React, { FC } from 'react'
import { Icon } from '@iconify/react'

import { Button } from '../../atoms'
import { useShowMessage } from '../../providers'
import { fetchFile } from '@pepper/utils/src/api/files/files'

import { FileList } from '../../molecules'
import styles from './_.module.css'

interface DesignSubmissionFilesProps {
  fileList: Attachment[]
}
export const DesignSubmissionFiles: FC<DesignSubmissionFilesProps> = ({
  fileList
}) => {
  const showMessage = useShowMessage()

  const downloadFile = async (
    e: React.MouseEvent<HTMLElement, MouseEvent> | null,
    id: string,
    fileName: string
  ) => {
    e && e.preventDefault()
    try {
      const response = await fetchFile({ id })
      const fileObjectURL = URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = fileObjectURL
      a.download = fileName
      document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click()
      a.remove() //afterwards we remove the element again
    } catch (error) {
      showMessage({ type: 'error', message: 'Could not open file.' })
    }
  }

  const handleView = async (id: string) => {
    try {
      const response = await fetchFile({ id })
      const fileObjectURL = URL.createObjectURL(response.data)
      window.open(fileObjectURL)
    } catch (error) {
      showMessage({ type: 'error', message: 'Could not open file.' })
    }
  }

  return (
    <div className={styles.popoverContainer}>
      <div className={styles.submissionFileHeader}>
        <div>Submissions</div>
      </div>
      <div>
        {fileList?.map((file, index) => (
          <div key={file.id} className={styles.fileListContainer}>
            <div className={styles.fileList}>
              <div>{index + 1}.</div>
              <div className={styles.fileName}>
                <FileList list={[file]} />
              </div>
            </div>
            <div className={styles.buttonWrapper}>
              <Button
                type="text"
                onClick={() => handleView(file.id)}
                icon={<Icon icon="ant-design:eye-outlined" />}
              />
              <Button
                type="text"
                onClick={event => downloadFile(event, file.id, file.name)}
                icon={<Icon icon="ant-design:download-outlined" />}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
